import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isIntegrationsDirectCdiValidationOverridesResult = objectOf({
  overrides: arrayOf(string),
});
